const getQueryParams = (obj: object) =>
    new URLSearchParams(obj as Record<string, string>).toString();

function urlWithQueryParams(url: string, object: unknown) {
  if (typeof object !== "object") return "";
  if (!url) return "";

  const params = getQueryParams(object as object);
  const hasParams = params.length > 0;

  return `${url}${hasParams ? `?${params}` : ``}`;
}
export default urlWithQueryParams;
